// src/reducers/productReducer.js

import {types} from '../types/types';

const initialState = {
    editingProduct: {
        id: 0,
        code: '',
        existence: true,
        formatter: '',
        freightChargeFk: '',
        name: '',
        ordinal: '',
        realmFk: '',
        status: true,
        visible: true
    },
    availableProducts: [] // ← Nuevo estado para filtros
};

export const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingProductInfo:
            return {
                ...state,
                editingProduct: action.payload
            };

        case types.clearProductInfo:
            return {
                ...state,
                editingProduct: initialState.editingProduct
            };

        case types.setAvailableProducts:
            return {
                ...state,
                availableProducts: action.payload
            };

        default:
            return state;
    }
};